<template lang="pug">
span
  v-menu(v-model="showMenu" rounded="lg" allow-overflow attach :close-on-content-click="false" offset-y max-height="420" min-width="320" max-width="320" nudge-bottom="8" z-index="11")
    template(v-slot:activator="{ on, attrs }")
      v-btn.px-2.button-text-normal.button-filter.text-none(v-if="selectedItems.length > 0" outlined rounded height="28" v-bind="attrs" v-on="on")
        v-icon.mr-1(@click.stop="clear" size=13) $yzi-x-circle
        .text-xs.font-semibold Order status
        .px-1.neutral400--text | 
        .text-xs.primary--text.font-medium {{ getSelectedStatus() }}
        v-icon.ml-1(size=16) $yzi-chevron-down
      v-btn.px-2.button-text-normal.border-dashed.button-filter(v-else outlined rounded height="28" v-bind="attrs" v-on="on")
        v-icon.mr-1(size=13) $yzi-plus-circle
        .text-xs.text-none.font-semibold Order status
    
    .white
      .menu-header.white
        .font-semibold.text-sm.pa-4 {{ $t('filter_by') }} order status
        v-divider
      div(v-for="status in statuses" :key="status.value")
        .d-flex.text-sm.px-4.py-3.cursor-pointer.hover-bg(@click="clickItem(status)")
          yc-checkbox(v-model="checkedItems" :value="status")
          .ml-4 {{ status.label }}
        v-divider.basic300
          
    .bottom-0.sticky.z-1.white
      .d-flex.align-center.px-4.py-3.border-t
        .text-sm.font-semibold.underline.normal-case.neutral700--text.cursor-pointer(v-if="!disabledButton" @click="clear") {{ $t('clear') }}
        v-spacer
        v-btn.button-sm(@click="apply" color="primary" depressed :disabled="disabledButton") {{ $t('apply') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    filter: {
      type: Object,
      default: () => ({})
    },
    filterKey: {
      type: String,
      default: 'order_status'
    },
  },
  components: {},
  data: () => ({
    showMenu: false,
    searchText: '',
    statuses: [
      {
        label: 'Draft',
        value: 'draft',
        checked: false
      },
      {
        label: 'Active',
        value: 'active',
        checked: false
      },
      {
        label: 'Completed',
        value: 'completed',
        checked: false
      },
      {
        label: 'Archived',
        value: 'archived',
        checked: false
      }
    ],
    checkedItems: [],
    selectedItems: [],
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    disabledButton () {
      return this.checkedItems.length === 0
    }
  },
  watch: {
    filter: {
      handler () {
        if (!this.filter.key) { this.clearData() }
      } 
    },
    showMenu (value) {
      if (!value) {
        this.checkedItems = [...this.selectedItems]
      }
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    clear () {
      this.clearData()
      this.$emit('update:filter', {})
    },
    clearData () {
      this.checkedItems = []
      this.selectedItems = []
    },
    apply () {
      this.showMenu = false
      this.selectedItems = [...this.checkedItems]
      this.$emit('update:filter', { key: this.filterKey, value: this.checkedItems.map(i => i.value).join(',')})
    },
    clickItem (item) {
      if (this.checkedItems.map(i => i.value).includes(item.value)) {
        this.checkedItems = this.checkedItems.filter(x => x.value !== item.value)
      } else {
        this.checkedItems.push(item)
      }
    },
    getSelectedStatus () {
      const count = this.selectedItems.length
      if (count <= 2) {
        return this.selectedItems.map(x => x.label).join(', ')
      }
      return `${count} selected`
    },
  }
}
</script>

<style lang="scss" scoped>
.button-filter {
  min-width: 0 !important;
  color: #848484;
}
.menu-header {
  top: 0;
  position: sticky;
  z-index: 1;
}
</style>